export class DataPeriod {
    dealerShipId: number;
    productCategoryId: string;
    productId: string;
    startDate: string; 
    endDate: string;
    start: number; 
    end: number;
    constructor(data) {
        this.dealerShipId =  data.dealerShipId;
        this.productCategoryId =  data.productCategoryId;
        this.productId =  data.productId;
        this.startDate =  data.startDate; 
        this.endDate =  data.endDate;
        this.start =  data.start; 
        this.end =  data.end;
    }
    
}


// WEBPACK FOOTER //
// ./src/app/components/class/rtb/table/data-period.ts